<template>
  <div id="pagination" v-if="page_number>1">
    <div id="pageInfo">
      <p class="note" style="margin-right:1rem">
        <span>{{(current_page-1)*10+1}}</span>-<span v-if="Number(current_page)===page_number">{{this.resultCount}}</span><span v-else>{{(current_page-1)*10+10}}</span> of <span>{{resultCount}}</span> <span v-if="resultCount>1">{{this.resultName}}s</span><span v-else>{{this.resultName}}</span></p>
      <p class="note">Go to page <input type="text" id="goToPage" v-model="go_to_page">
        <router-link v-if="this.$route.path.includes('search')" :to="{name:'search_result', params:{page:Number(go_to_page)}, query:{keyword:keyword, domain:domain, platform:platform}}">
          <input type="submit" id="goToPagebtn" value="go" class="btnMini" @click="returnPage({index:Number(goToPage), current_page:true})">
        </router-link>
        <router-link v-if="this.$route.path.includes('domain')" :to="{name:'all_courses_domain', params:{domain_name:domain_name, page:Number(go_to_page)}, query:{platform:platform}}">
          <input type="submit" id="goToPagebtn" value="go" class="btnMini" @click="returnPage({index:Number(goToPage), current_page:true})">
        </router-link>
        <router-link v-if="this.$route.path.includes('provider')" :to="{name:'all_courses_provider', params:{provider_name:provider_name, page:Number(go_to_page)}, query:{domain:domain,platform:platform}}">
          <input type="submit" id="goToPagebtn" value="go" class="btnMini" @click="returnPage({index:Number(goToPage), current_page:true})">
        </router-link>
      </p>
    </div>

    <!--if the page is search result page-->
    <div id="pages" v-if="this.$route.path.includes('search')">
      <!--go to the first page-->
      <router-link :to="{name:'search_result', params:{page:1}, query:{keyword:keyword, domain:domain, platform:platform}}"><i class="fas fa-angle-double-left" :class="{deactivate:Number(current_page)===1}"></i></router-link>

      <!--go to the previous page-->
      <p v-if="Number(current_page)===1" style="margin:0 10px; color:#BFC2CB;" class="note">Prev</p>
      <router-link :to="{name:'search_result', params:{page:Number(current_page)-1}, query:{keyword:keyword, domain:domain, platform:platform}}" v-else style="margin:0 10px" class="note" @click="paginate">Prev</router-link>

      <p class="dot" v-show="dot1">...</p>

      <router-link :to="{name:'search_result', params:{page:page.index}, query:{keyword:keyword, domain:domain, platform:platform}}" v-for="page in pages1">
        <span class="page" :class="{currentPage:page.index===Number(current_page)}">{{page.index}}</span>
      </router-link>

      <p class="dot" v-show="dot2">...</p>

      <router-link :to="{name:'search_result', params:{page:page.index}, query:{keyword:keyword, domain:domain, platform:platform}}" v-for="page in pages2">
        <span class="page" :class="{currentPage:page.index===Number(current_page)}">{{page.index}}</span>
      </router-link>

      <!--go to the next page-->
      <p v-if="Number(current_page)===page_number" style="margin:0 10px; color:#BFC2CB;" class="note">Next</p>
      <router-link :to="{name:'search_result', params:{page:Number(current_page)+1}, query:{keyword:keyword, domain:domain, platform:platform}}" v-else style="margin:0 10px" class="note" @click="paginate">Next</router-link>

      <!--go to the last page-->
      <router-link :to="{name:'search_result', params:{page:page_number}, query:{keyword:keyword, domain:domain, platform:platform}}"><i class="fas fa-angle-double-right" :class="{deactivate:Number(current_page)===page_number}"></i></router-link>
    </div>

    <!--if the page is all courses of a domain-->
    <div id="pages" v-if="this.$route.path.includes('domain')">
      <!--:to="{name:'all_courses_domain', params:{domain_name:this.title, page:1}}"-->
      <!--go to the first page-->
      <router-link :to="{name:'all_courses_domain', params:{domain_name:domain_name,page:1}, query:{platform:platform}}"><i class="fas fa-angle-double-left" :class="{deactivate:Number(current_page)===1}"></i></router-link>

      <!--go to the previous page-->
      <p v-if="Number(current_page)===1" style="margin:0 10px; color:#BFC2CB;" class="note">Prev</p>
      <router-link :to="{name:'all_courses_domain', params:{domain_name:domain_name,page:Number(current_page)-1}, query:{platform:platform}}" v-else style="margin:0 10px" class="note" @click="paginate">Prev</router-link>

      <p class="dot" v-show="dot1">...</p>

      <router-link :to="{name:'all_courses_domain', params:{domain_name:domain_name,page:page.index}, query:{platform:platform}}" v-for="page in pages1">
        <span class="page" :class="{currentPage:page.index===Number(current_page)}">{{page.index}}</span>
      </router-link>

      <p class="dot" v-show="dot2">...</p>

      <router-link :to="{name:'all_courses_domain', params:{domain_name:domain_name, page:page.index}, query:{platform:platform}}" v-for="page in pages2">
        <span class="page" :class="{currentPage:page.index===Number(current_page)}">{{page.index}}</span>
      </router-link>

      <!--go to the next page-->
      <p v-if="Number(current_page)===page_number" style="margin:0 10px; color:#BFC2CB;" class="note">Next</p>
      <router-link :to="{name:'all_courses_domain', params:{domain_name:domain_name, page:Number(current_page)+1}, query:{platform:platform}}" v-else style="margin:0 10px" class="note" @click="paginate">Next</router-link>

      <!--go to the last page-->
      <router-link :to="{name:'all_courses_domain', params:{domain_name:domain_name, page:page_number}, query:{platform:platform}}"><i class="fas fa-angle-double-right" :class="{deactivate:Number(current_page)===page_number}"></i></router-link>
    </div>

    <!--if the page is all courses of a provider-->
    <div id="pages" v-if="this.$route.path.includes('provider')">
      <!--:to="{name:'all_courses_domain', params:{domain_name:this.title, page:1}}"-->
      <!--go to the first page-->
      <router-link :to="{name:'all_courses_provider', params:{provider_id:provider_id,page:1}, query:{domain:domain,platform:platform}}"><i class="fas fa-angle-double-left" :class="{deactivate:Number(current_page)===1}"></i></router-link>

      <!--go to the previous page-->
      <p v-if="Number(current_page)===1" style="margin:0 10px; color:#BFC2CB;" class="note">Prev</p>
      <router-link :to="{name:'all_courses_provider', params:{provider_id:provider_id,page:Number(current_page)-1}, query:{domain:domain,platform:platform}}" v-else style="margin:0 10px" class="note" @click="paginate">Prev</router-link>

      <p class="dot" v-show="dot1">...</p>

      <router-link :to="{name:'all_courses_provider', params:{provider_id:provider_id,page:page.index}, query:{domain:domain,platform:platform}}" v-for="page in pages1">
        <span class="page" :class="{currentPage:page.index===Number(current_page)}">{{page.index}}</span>
      </router-link>

      <p class="dot" v-show="dot2">...</p>

      <router-link :to="{name:'all_courses_provider', params:{provider_id:provider_id, page:page.index}, query:{domain:domain,platform:platform}}" v-for="page in pages2">
        <span class="page" :class="{currentPage:page.index===Number(current_page)}">{{page.index}}</span>
      </router-link>

      <!--go to the next page-->
      <p v-if="Number(current_page)===page_number" style="margin:0 10px; color:#BFC2CB;" class="note">Next</p>
      <router-link :to="{name:'all_courses_provider', params:{provider_id:provider_id, page:Number(current_page)+1}, query:{domain:domain,platform:platform}}" v-else style="margin:0 10px" class="note" @click="paginate">Next</router-link>

      <!--go to the last page-->
      <router-link :to="{name:'all_courses_provider', params:{provider_id:provider_id, page:page_number}, query:{domain:domain,platform:platform}}"><i class="fas fa-angle-double-right" :class="{deactivate:Number(current_page)===page_number}"></i></router-link>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    goToPage: Number,
    resultCount: Number,
    resultName:String
  },
  data(){
    return{
      dot1: false,
      dot2: false,
      pages1:[],
      pages2:[],
      go_to_page:""
    }
  },
  computed:{
    page_number: function() {
      return Math.ceil(this.resultCount / 10)
    },
    domain_name:function(){
      return this.$route.params.domain_name
    },
    provider_id:function(){
      return this.$route.params.provider_id
    },
    current_page:function(){
      return this.$route.params.page
    },
    domain:function(){
      return this.$route.query.domain
    },
    platform:function(){
      return this.$route.query.platform
    },
    keyword:function(){
      return this.$route.query.keyword
    },
    paginate: function(){
      if (this.page_number <= 10) {
        this.pages1 = []
        this.pages2 = []
        this.dot1 = false
        this.dot2 = false
        for (let i = 1; i <= this.page_number; i++) {
          let page = {index: i}
          this.pages1.push(page)
        }
      }
      else{
       if (Number(this.current_page) <= 3){
         this.dot1 = false
         this.pages1 = [{index: 1, current_page: true}, {index: 2, current_page: false}, {index: 3, current_page: false}]
         this.dot2 = true
         this.pages2 = [{index: this.page_number - 2, current_page: false}, {index: this.page_number - 1, current_page: false}, {index: this.page_number, current_page: false}]
       }
        else if (Number(this.current_page) < this.page_number-5){
          this.dot1 = true
          this.pages1 = [{index: Number(this.current_page), current_page: true}, {index: Number(this.current_page) + 1, current_page: false}, {index: Number(this.current_page) + 2, current_page: false}]
          this.dot2 = true
          this.pages2 = [{index: this.page_number - 2, current_page: false}, {index: this.page_number - 1, current_page: false}, {index: this.page_number, current_page: false}]
        }
        else {
          this.dot1 = true
          this.pages1 = [{index: this.page_number - 5, current_page: false}, {index: this.page_number - 4, current_page: false}, {index: this.page_number - 3, current_page: false}, {index: this.page_number - 2, current_page: false}, {index: this.page_number - 1, current_page: false}, {index: this.page_number, current_page: false}]
          this.dot2 = false
          this.pages2 = []
        }
      }
    }
  },
  methods: {
    enterGoToPage: function () {
      document.getElementById('goToPage').addEventListener('keyup', function (event) {
        if (event.keyCode === 13) {
          event.preventDefault();
          document.getElementById('goToPagebtn').click()
        }
      })
    }
  },
  mounted () {
    this.enterGoToPage()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/General/Pagination.vue